"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Enum = props => {
  const {
    value,
    name,
    format,
    schema,
    onChange
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", null, Object.entries(schema.options).map(([key, val], index) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "custom-control custom-radio",
      key: index
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "radio",
      className: 'custom-control-input',
      id: name + key,
      name: name,
      checked: val === value || parseInt(key) === value,
      onChange: () => onChange(parseInt(key))
    }), /*#__PURE__*/_react.default.createElement("label", {
      className: "custom-control-label",
      htmlFor: name + key
    }, val));
  }));
};
var _default = exports.default = Enum;
module.exports = exports.default;